/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { ternaryCondition, history } from "helpers/utis";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
export function ListItem({ icon, activeIcon, module, link, isOpen }) {
  const [isActiveItem, setIsActiveItem] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsActiveItem(location.pathname.startsWith(link));
  }, [location.pathname]);

  const handleClick = (routeLink) => {
    setIsActiveItem(location.pathname.startsWith(link));
    return history.push(routeLink);
  };

  return (
    <li
      className={`mb-1 cursor-pointer ${ternaryCondition(
        isActiveItem,
        "active-item",
        "",
      )}`}
      title={!isOpen ? module : ""}
    >
      <button
        type="button"
        onClick={() => handleClick(link)}
        className={`sidebar-menu-button ${
          isOpen ? "sidebar-container d-flex p-3" : "closedImgIcon p-3"
        }`}
        aria-label={module}
      >
        <img src={isActiveItem ? activeIcon : icon} className="mr-1" alt="sidebar-icon" />

        {isOpen && (
          <span className={ternaryCondition(isActiveItem, "active-item", "")}>
            {module}
          </span>
        )}
      </button>
    </li>
  );
}

ListItem.propTypes = {
  icon: PropTypes.string,
  activeIcon: PropTypes.string,
  module: PropTypes.string,
  link: PropTypes.string,
  isOpen: PropTypes.bool,
};

ListItem.defaultProps = {
  icon: "",
  activeIcon: "",
  module: "",
  link: "",
  isOpen: true,
};
